import { MediaQueryEnum, useMediaQuery } from 'commons/utils';
import { MenuBar } from 'molecules/MenuBar';
import { MenuButton } from 'molecules/MenuButton';

const MENU_HEIGHT = 40;

export const AppMenu = () => {
  if (useMediaQuery(MediaQueryEnum.sp)) {
    return <MenuButton height={MENU_HEIGHT}></MenuButton>;
  } else {
    return <MenuBar></MenuBar>;
  }
};
